// Font Awesome Pro 6.4.0 regular icons, copied from the @rq-ratings/pro-regular-svg-icons
// package so the app no longer needs a GitHub Packages token to install.
// Our Pro licence has expired; it still covers 6.4.0 but not newer versions.
// Do not add icons here. See LICENSE.txt in this folder.

import type { IconDefinition } from '@fortawesome/fontawesome-svg-core'

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faAngleDown: IconDefinition = {
  prefix: 'far',
  iconName: 'angle-down',
  icon: [
    448,
    512,
    [],
    'f107',
    'M241 337c-9.4 9.4-24.6 9.4-33.9 0L47 177c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l143 143L367 143c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L241 337z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faAngleRight: IconDefinition = {
  prefix: 'far',
  iconName: 'angle-right',
  icon: [
    320,
    512,
    [],
    'f105',
    'M273 239c9.4 9.4 9.4 24.6 0 33.9L113 433c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l143-143L79 113c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L273 239z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faAngleUp: IconDefinition = {
  prefix: 'far',
  iconName: 'angle-up',
  icon: [
    448,
    512,
    [],
    'f106',
    'M207 143c9.4-9.4 24.6-9.4 33.9 0L401 303c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-143-143L81 337c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L207 143z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faArrowDown: IconDefinition = {
  prefix: 'far',
  iconName: 'arrow-down',
  icon: [
    384,
    512,
    [],
    'f063',
    'M174.6 472.6c4.5 4.7 10.8 7.4 17.4 7.4s12.8-2.7 17.4-7.4l168-176c9.2-9.6 8.8-24.8-.8-33.9s-24.8-8.8-33.9 .8L216 396.1 216 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 340.1L41.4 263.4c-9.2-9.6-24.3-9.9-33.9-.8s-9.9 24.3-.8 33.9l168 176z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faArrowLeft: IconDefinition = {
  prefix: 'far',
  iconName: 'arrow-left',
  icon: [
    448,
    512,
    [],
    'f060',
    'M7.4 273.4C2.7 268.8 0 262.6 0 256s2.7-12.8 7.4-17.4l176-168c9.6-9.2 24.8-8.8 33.9 .8s8.8 24.8-.8 33.9L83.9 232 424 232c13.3 0 24 10.7 24 24s-10.7 24-24 24L83.9 280 216.6 406.6c9.6 9.2 9.9 24.3 .8 33.9s-24.3 9.9-33.9 .8l-176-168z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faArrowRight: IconDefinition = {
  prefix: 'far',
  iconName: 'arrow-right',
  icon: [
    448,
    512,
    [],
    'f061',
    'M440.6 273.4c4.7-4.5 7.4-10.8 7.4-17.4s-2.7-12.8-7.4-17.4l-176-168c-9.6-9.2-24.8-8.8-33.9 .8s-8.8 24.8 .8 33.9L364.1 232 24 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l340.1 0L231.4 406.6c-9.6 9.2-9.9 24.3-.8 33.9s24.3 9.9 33.9 .8l176-168z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faArrowRotateRight: IconDefinition = {
  prefix: 'far',
  iconName: 'arrow-rotate-right',
  icon: [
    512,
    512,
    ['arrow-right-rotate', 'arrow-rotate-forward', 'redo'],
    'f01e',
    'M472 224c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24s-24 10.7-24 24v80.1l-20-23.5C387 63.4 325.1 32 256 32C132.3 32 32 132.3 32 256s100.3 224 224 224c50.4 0 97-16.7 134.4-44.8c10.6-8 12.7-23 4.8-33.6s-23-12.7-33.6-4.8C332.2 418.9 295.7 432 256 432c-97.2 0-176-78.8-176-176s78.8-176 176-176c54.3 0 102.9 24.6 135.2 63.4l.1 .2 0 0L418.9 176H328c-13.3 0-24 10.7-24 24s10.7 24 24 24H472z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faArrowUp: IconDefinition = {
  prefix: 'far',
  iconName: 'arrow-up',
  icon: [
    384,
    512,
    [],
    'f062',
    'M209.4 39.4C204.8 34.7 198.6 32 192 32s-12.8 2.7-17.4 7.4l-168 176c-9.2 9.6-8.8 24.8 .8 33.9s24.8 8.8 33.9-.8L168 115.9V456c0 13.3 10.7 24 24 24s24-10.7 24-24V115.9L342.6 248.6c9.2 9.6 24.3 9.9 33.9 .8s9.9-24.3 .8-33.9l-168-176z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faArrowUpRightFromSquare: IconDefinition = {
  prefix: 'far',
  iconName: 'arrow-up-right-from-square',
  icon: [
    512,
    512,
    ['external-link'],
    'f08e',
    'M304 24c0 13.3 10.7 24 24 24H430.1L207 271c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l223-223V184c0 13.3 10.7 24 24 24s24-10.7 24-24V24c0-13.3-10.7-24-24-24H328c-13.3 0-24 10.7-24 24zM72 32C32.2 32 0 64.2 0 104V440c0 39.8 32.2 72 72 72H408c39.8 0 72-32.2 72-72V312c0-13.3-10.7-24-24-24s-24 10.7-24 24V440c0 13.3-10.7 24-24 24H72c-13.3 0-24-10.7-24-24V104c0-13.3 10.7-24 24-24H200c13.3 0 24-10.7 24-24s-10.7-24-24-24H72z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faBan: IconDefinition = {
  prefix: 'far',
  iconName: 'ban',
  icon: [
    512,
    512,
    ['cancel'],
    'f05e',
    'M385.1 419.1L92.9 126.9C64.8 162.3 48 207.2 48 256c0 114.9 93.1 208 208 208c48.8 0 93.7-16.8 129.1-44.9zm33.9-33.9C447.2 349.7 464 304.8 464 256c0-114.9-93.1-208-208-208c-48.8 0-93.7 16.8-129.1 44.9L419.1 385.1zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faBars: IconDefinition = {
  prefix: 'far',
  iconName: 'bars',
  icon: [
    448,
    512,
    ['navicon'],
    'f0c9',
    'M0 88C0 74.7 10.7 64 24 64H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H24C10.7 112 0 101.3 0 88zM0 248c0-13.3 10.7-24 24-24H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24zM448 408c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H424c13.3 0 24 10.7 24 24z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faBriefcase: IconDefinition = {
  prefix: 'far',
  iconName: 'briefcase',
  icon: [
    512,
    512,
    [],
    'f0b1',
    'M176 56V96H336V56c0-4.4-3.6-8-8-8H184c-4.4 0-8 3.6-8 8zM128 96V56c0-30.9 25.1-56 56-56H328c30.9 0 56 25.1 56 56V96h64c35.3 0 64 28.7 64 64V280 416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V280 160c0-35.3 28.7-64 64-64h64zM48 304V416c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V304H320v16c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V304H48zm144-48H320 464V160c0-8.8-7.2-16-16-16H360 152 64c-8.8 0-16 7.2-16 16v96H192z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faCheck: IconDefinition = {
  prefix: 'far',
  iconName: 'check',
  icon: [
    448,
    512,
    [],
    'f00c',
    'M441 103c9.4 9.4 9.4 24.6 0 33.9L177 401c-9.4 9.4-24.6 9.4-33.9 0L7 265c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l119 119L407 103c9.4-9.4 24.6-9.4 33.9 0z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faCheckCircle: IconDefinition = {
  prefix: 'far',
  iconName: 'circle-check',
  icon: [
    512,
    512,
    ['check-circle'],
    'f058',
    'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faChevronLeft: IconDefinition = {
  prefix: 'far',
  iconName: 'chevron-left',
  icon: [
    320,
    512,
    [],
    'f053',
    'M15 239c-9.4 9.4-9.4 24.6 0 33.9L207 465c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L65.9 256 241 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L15 239z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faChevronRight: IconDefinition = {
  prefix: 'far',
  iconName: 'chevron-right',
  icon: [
    320,
    512,
    [],
    'f054',
    'M305 239c9.4 9.4 9.4 24.6 0 33.9L113 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L79 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L305 239z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faCircleCheck: IconDefinition = {
  prefix: 'far',
  iconName: 'circle-check',
  icon: [
    512,
    512,
    ['check-circle'],
    'f058',
    'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faCircleExclamation: IconDefinition = {
  prefix: 'far',
  iconName: 'circle-exclamation',
  icon: [
    512,
    512,
    ['exclamation-circle'],
    'f06a',
    'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c-13.3 0-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V152c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faCircleMinus: IconDefinition = {
  prefix: 'far',
  iconName: 'circle-minus',
  icon: [
    512,
    512,
    ['minus-circle'],
    'f056',
    'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 232c-13.3 0-24 10.7-24 24s10.7 24 24 24H328c13.3 0 24-10.7 24-24s-10.7-24-24-24H184z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faCirclePause: IconDefinition = {
  prefix: 'far',
  iconName: 'circle-pause',
  icon: [
    512,
    512,
    ['pause-circle'],
    'f28b',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm224-72V328c0 13.3-10.7 24-24 24s-24-10.7-24-24V184c0-13.3 10.7-24 24-24s24 10.7 24 24zm112 0V328c0 13.3-10.7 24-24 24s-24-10.7-24-24V184c0-13.3 10.7-24 24-24s24 10.7 24 24z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faClipboard: IconDefinition = {
  prefix: 'far',
  iconName: 'clipboard',
  icon: [
    384,
    512,
    [],
    'f328',
    'M280 64h40c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128C0 92.7 28.7 64 64 64h40 9.6C121 27.5 153.3 0 192 0s71 27.5 78.4 64H280zM64 112c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16H320c8.8 0 16-7.2 16-16V128c0-8.8-7.2-16-16-16H304v24c0 13.3-10.7 24-24 24H192 104c-13.3 0-24-10.7-24-24V112H64zm128-8a24 24 0 1 0 0-48 24 24 0 1 0 0 48z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faClock: IconDefinition = {
  prefix: 'far',
  iconName: 'clock',
  icon: [
    512,
    512,
    ['clock-four'],
    'f017',
    'M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120V256c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faEnvelope: IconDefinition = {
  prefix: 'far',
  iconName: 'envelope',
  icon: [
    512,
    512,
    [],
    'f0e0',
    'M64 112c-8.8 0-16 7.2-16 16v22.1L220.5 291.7c20.7 17 50.4 17 71.1 0L464 150.1V128c0-8.8-7.2-16-16-16H64zM48 212.2V384c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V212.2L322 328.8c-38.4 31.5-93.7 31.5-132 0L48 212.2zM0 128C0 92.7 28.7 64 64 64H448c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faExclamationCircle: IconDefinition = {
  prefix: 'far',
  iconName: 'circle-exclamation',
  icon: [
    512,
    512,
    ['exclamation-circle'],
    'f06a',
    'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c-13.3 0-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V152c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faExclamationTriangle: IconDefinition = {
  prefix: 'far',
  iconName: 'triangle-exclamation',
  icon: [
    512,
    512,
    ['exclamation-triangle', 'warning'],
    'f071',
    'M248.4 84.3c1.6-2.7 4.5-4.3 7.6-4.3s6 1.6 7.6 4.3L461.9 410c1.4 2.3 2.1 4.9 2.1 7.5c0 8-6.5 14.5-14.5 14.5H62.5c-8 0-14.5-6.5-14.5-14.5c0-2.7 .7-5.3 2.1-7.5L248.4 84.3zm-41-25L9.1 385c-6 9.8-9.1 21-9.1 32.5C0 452 28 480 62.5 480h387c34.5 0 62.5-28 62.5-62.5c0-11.5-3.2-22.7-9.1-32.5L304.6 59.3C294.3 42.4 275.9 32 256 32s-38.3 10.4-48.6 27.3zM288 368a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-8-184c0-13.3-10.7-24-24-24s-24 10.7-24 24v96c0 13.3 10.7 24 24 24s24-10.7 24-24V184z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faEyeSlash: IconDefinition = {
  prefix: 'far',
  iconName: 'eye-slash',
  icon: [
    640,
    512,
    [],
    'f070',
    'M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zm151 118.3C226 97.7 269.5 80 320 80c65.2 0 118.8 29.6 159.9 67.7C518.4 183.5 545 226 558.6 256c-12.6 28-36.6 66.8-70.9 100.9l-53.8-42.2c9.1-17.6 14.2-37.5 14.2-58.7c0-70.7-57.3-128-128-128c-32.2 0-61.7 11.9-84.2 31.5l-46.1-36.1zM394.9 284.2l-81.5-63.9c4.2-8.5 6.6-18.2 6.6-28.3c0-5.5-.7-10.9-2-16c.7 0 1.3 0 2 0c44.2 0 80 35.8 80 80c0 9.9-1.8 19.4-5.1 28.2zm9.4 130.3C378.8 425.4 350.7 432 320 432c-65.2 0-118.8-29.6-159.9-67.7C121.6 328.5 95 286 81.4 256c8.3-18.4 21.5-41.5 39.4-64.8L83.1 161.5C60.3 191.2 44 220.8 34.5 243.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 89.9-12.9 126.2-32.5l-41.9-33zM192 256c0 70.7 57.3 128 128 128c13.3 0 26.1-2 38.2-5.8L302 334c-23.5-5.4-43.1-21.2-53.7-42.3l-56.1-44.2c-.2 2.8-.3 5.6-.3 8.5z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faFileArrowDown: IconDefinition = {
  prefix: 'far',
  iconName: 'file-arrow-down',
  icon: [
    384,
    512,
    ['file-download'],
    'f56d',
    'M48 448V64c0-8.8 7.2-16 16-16H224v80c0 17.7 14.3 32 32 32h80V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0H64zM216 232c0-13.3-10.7-24-24-24s-24 10.7-24 24V334.1l-31-31c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c9.4 9.4 24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-31 31V232z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faFilterSlash: IconDefinition = {
  prefix: 'far',
  iconName: 'filter-slash',
  icon: [
    640,
    512,
    [],
    'e17d',
    'M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L408.1 294.6 566.6 100c6.1-7.4 9.4-16.7 9.4-26.3c0-23-18.7-41.7-41.7-41.7h-429c-8.6 0-16.5 2.6-23.1 7.1L38.8 5.1zM134.4 80H521L370.3 265 134.4 80zM288 364.4V322.9l-48-37.8v83.2c0 12.2 5.6 23.7 15.1 31.3L347.6 473c5.7 4.5 12.8 7 20.1 7c17.8 0 32.3-14.5 32.3-32.3V411.2l-48-37.8v41.9l-64-50.8z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faInfoCircle: IconDefinition = {
  prefix: 'far',
  iconName: 'circle-info',
  icon: [
    512,
    512,
    ['info-circle'],
    'f05a',
    'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V248c0-13.3-10.7-24-24-24H216c-13.3 0-24 10.7-24 24s10.7 24 24 24h24v64H216zm40-144a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faList: IconDefinition = {
  prefix: 'far',
  iconName: 'list',
  icon: [
    512,
    512,
    ['list-squares'],
    'f03a',
    'M40 48C26.7 48 16 58.7 16 72v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V72c0-13.3-10.7-24-24-24H40zM184 72c-13.3 0-24 10.7-24 24s10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H184zm0 160c-13.3 0-24 10.7-24 24s10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H184zm0 160c-13.3 0-24 10.7-24 24s10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H184zM16 232v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V232c0-13.3-10.7-24-24-24H40c-13.3 0-24 10.7-24 24zM40 368c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V392c0-13.3-10.7-24-24-24H40z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faLock: IconDefinition = {
  prefix: 'far',
  iconName: 'lock',
  icon: [
    448,
    512,
    [],
    'f023',
    'M144 128v64H304V128c0-44.2-35.8-80-80-80s-80 35.8-80 80zM96 192V128C96 57.3 153.3 0 224 0s128 57.3 128 128v64h32c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256c0-35.3 28.7-64 64-64H96zM48 256V448c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V256c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faLongArrowLeft: IconDefinition = {
  prefix: 'far',
  iconName: 'arrow-left-long',
  icon: [
    512,
    512,
    ['long-arrow-left'],
    'f177',
    'M7 239c-9.4 9.4-9.4 24.6 0 33.9L143 409c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-95-95L488 280c13.3 0 24-10.7 24-24s-10.7-24-24-24L81.9 232l95-95c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L7 239z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faLongArrowRight: IconDefinition = {
  prefix: 'far',
  iconName: 'arrow-right-long',
  icon: [
    512,
    512,
    ['long-arrow-right'],
    'f178',
    'M505 273c9.4-9.4 9.4-24.6 0-33.9L369 103c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l95 95L24 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l406.1 0-95 95c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L505 273z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faMagnifyingGlass: IconDefinition = {
  prefix: 'far',
  iconName: 'magnifying-glass',
  icon: [
    512,
    512,
    ['search'],
    'f002',
    'M368 208A160 160 0 1 0 48 208a160 160 0 1 0 320 0zM337.1 371.1C301.7 399.2 256.8 416 208 416C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208c0 48.8-16.8 93.7-44.9 129.1L505 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L337.1 371.1z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faMapMarkerAlt: IconDefinition = {
  prefix: 'far',
  iconName: 'location-dot',
  icon: [
    384,
    512,
    ['map-marker-alt'],
    'f3c5',
    'M336 192c0-79.5-64.5-144-144-144S48 112.5 48 192c0 12.4 4.5 31.6 15.3 57.2c10.5 24.8 25.4 52.2 42.5 79.9c28.5 46.2 61.5 90.8 86.2 122.6c24.8-31.8 57.8-76.4 86.2-122.6c17.1-27.7 32-55.1 42.5-79.9C331.5 223.6 336 204.4 336 192zm48 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zm-160 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-112 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faPaperPlane: IconDefinition = {
  prefix: 'far',
  iconName: 'paper-plane',
  icon: [
    512,
    512,
    [],
    'f1d8',
    'M16.1 260.2c-22.6 12.9-20.5 47.3 3.6 57.3L160 376V479.3c0 18.1 14.6 32.7 32.7 32.7c9.7 0 18.9-4.3 25.1-11.8l62-74.3 123.9 51.6c18.9 7.9 40.8-4.5 43.9-24.7l64-416c1.9-12.1-3.4-24.3-13.5-31.2s-23.3-7.5-34-1.4l-448 256zm52.1 25.5L409.7 90.6 190.1 336l1.2 1L68.2 285.7zM403.3 425.4L236.7 355.9 450.8 116.6 403.3 425.4z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faPaperclip: IconDefinition = {
  prefix: 'far',
  iconName: 'paperclip',
  icon: [
    448,
    512,
    [],
    'f0c6',
    'M375 73c-26-26-68.1-26-94.1 0L89 265C45.3 308.6 45.3 379.4 89 423s114.4 43.6 158.1 0L399 271c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L281 457c-62.4 62.4-163.5 62.4-225.9 0S-7.4 293.4 55 231L247 39C291.7-5.7 364.2-5.7 409 39s44.7 117.2 0 161.9L225.2 384.7c-31.6 31.6-83.6 28.7-111.5-6.2c-23.8-29.8-21.5-72.8 5.5-99.8L271 127c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L153.2 312.7c-9.7 9.7-10.6 25.1-2 35.8c10 12.5 28.7 13.6 40 2.2L375 167c26-26 26-68.1 0-94.1z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faPenField: IconDefinition = {
  prefix: 'far',
  iconName: 'pen-field',
  icon: [
    640,
    512,
    [],
    'e211',
    'M569.2 59.1L581.1 71c9.4 9.4 9.4 24.6 0 33.9L560 126.1 514.3 80.4l20.8-21.1c9.4-9.5 24.6-9.5 34.1-.1zM359.9 236.8L480.6 114.5 526.1 160 404.6 281.6c-3.3 3.3-7.5 5.6-12 6.5L343 298.5l10.4-49.7c.9-4.5 3.2-8.7 6.4-11.9zM501 25.5L325.7 203.1c-9.7 9.8-16.4 22.3-19.2 35.8l-18 85.7c-1.7 7.9 .8 16.2 6.5 21.9s14 8.2 21.9 6.5l85.5-17.9c13.7-2.9 26.2-9.7 36.1-19.6L615.1 138.9c28.1-28.1 28.1-73.7 0-101.8L603.1 25.2C574.9-3.1 529-2.9 501 25.5zM72 128c-39.8 0-72 32.2-72 72V440c0 39.8 32.2 72 72 72H504c39.8 0 72-32.2 72-72V312c0-13.3-10.7-24-24-24s-24 10.7-24 24V440c0 13.3-10.7 24-24 24H72c-13.3 0-24-10.7-24-24V200c0-13.3 10.7-24 24-24H264c13.3 0 24-10.7 24-24s-10.7-24-24-24H72zm56 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faPencil: IconDefinition = {
  prefix: 'far',
  iconName: 'pencil',
  icon: [
    512,
    512,
    ['pencil-alt'],
    'f303',
    'M36.4 360.9L13.4 439 1 481.2C-1.5 489.7 .8 498.8 7 505s15.3 8.5 23.7 6.1L73 498.6l78.1-23c10.4-3 20.1-8 28.6-14.5l.3 .2 .5-.8c1.4-1.1 2.7-2.2 4-3.3c1.4-1.2 2.7-2.5 4-3.8L492.7 149.3c21.9-21.9 24.6-55.6 8.2-80.5c-2.3-3.5-5.1-6.9-8.2-10L453.3 19.3c-25-25-65.5-25-90.5 0L58.6 323.5c-2.5 2.5-4.9 5.2-7.1 8l-.8 .5 .2 .3c-6.5 8.5-11.4 18.2-14.5 28.6zM383 191L197.4 376.6l-49.6-12.4-12.4-49.6L321 129 383 191zM97 358.9l7.7 31c2.1 8.6 8.9 15.3 17.5 17.5l31 7.7-7.4 11.2c-2.6 1.4-5.3 2.6-8.1 3.4l-23.4 6.9L59.4 452.6l16.1-54.8 6.9-23.4c.8-2.8 2-5.6 3.4-8.1L97 358.9zM315.3 218.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l96-96z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faPlug: IconDefinition = {
  prefix: 'far',
  iconName: 'plug',
  icon: [
    384,
    512,
    [],
    'f1e6',
    'M128 24c0-13.3-10.7-24-24-24S80 10.7 80 24v88h48V24zm176 0c0-13.3-10.7-24-24-24s-24 10.7-24 24v88h48V24zM24 144c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v64c0 80.2 59 146.6 136 158.2V488c0 13.3 10.7 24 24 24s24-10.7 24-24V414.2c77-11.6 136-78 136-158.2V192h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8H304 80 32 24zM192 368c-61.9 0-112-50.1-112-112V192H304v64c0 61.9-50.1 112-112 112z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faPlugCircleBolt: IconDefinition = {
  prefix: 'far',
  iconName: 'plug-circle-bolt',
  icon: [
    576,
    512,
    [],
    'e55b',
    'M128 24c0-13.3-10.7-24-24-24S80 10.7 80 24v88h48V24zm176 0c0-13.3-10.7-24-24-24s-24 10.7-24 24v88h48V24zM24 144c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v64c0 80.2 59 146.6 136 158.2V488c0 13.3 10.7 24 24 24s24-10.7 24-24V414.2c15.2-2.3 29.7-6.7 43.1-12.9c-2.1-10.8-3.1-21.9-3.1-33.3c0-7.1 .4-14.1 1.2-20.9C238.9 360.2 216.3 368 192 368c-61.9 0-112-50.1-112-112V192H304v55.2c13.8-14.6 30-26.8 48-36V192h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8H304 80 32 24zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm47.9-225c4.3 3.7 5.4 9.9 2.6 14.9L452.4 356H488c5.2 0 9.8 3.3 11.4 8.2s-.1 10.3-4.2 13.4l-96 72c-4.5 3.4-10.8 3.2-15.1-.6s-5.4-9.9-2.6-14.9L411.6 380H376c-5.2 0-9.8-3.3-11.4-8.2s.1-10.3 4.2-13.4l96-72c4.5-3.4 10.8-3.2 15.1 .6z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faPlus: IconDefinition = {
  prefix: 'far',
  iconName: 'plus',
  icon: [
    448,
    512,
    ['add'],
    '2b',
    'M248 72c0-13.3-10.7-24-24-24s-24 10.7-24 24V232H40c-13.3 0-24 10.7-24 24s10.7 24 24 24H200V440c0 13.3 10.7 24 24 24s24-10.7 24-24V280H408c13.3 0 24-10.7 24-24s-10.7-24-24-24H248V72z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faQuestionCircle: IconDefinition = {
  prefix: 'far',
  iconName: 'circle-question',
  icon: [
    512,
    512,
    ['question-circle'],
    'f059',
    'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm169.8-90.7c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V250.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H222.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faRefresh: IconDefinition = {
  prefix: 'far',
  iconName: 'arrows-rotate',
  icon: [
    512,
    512,
    ['refresh', 'sync'],
    'f021',
    'M496 200c0 13.3-10.7 24-24 24h0H360 328c-13.3 0-24-10.7-24-24s10.7-24 24-24h32 54.1l-52.1-52.1C333.8 95.8 295.7 80 256 80c-72.7 0-135.2 44.1-162 107.1c-5.2 12.2-19.3 17.9-31.5 12.7s-17.9-19.3-12.7-31.5C83.9 88.2 163.4 32 256 32c52.5 0 102.8 20.8 139.9 57.9L448 142.1V88l0-.4V56c0-13.3 10.7-24 24-24s24 10.7 24 24V200zM40 288H152c13.3 0 24 10.7 24 24s-10.7 24-24 24H97.9l52.1 52.1C178.2 416.2 216.3 432 256 432c72.6 0 135-43.9 161.9-106.8c5.2-12.2 19.3-17.8 31.5-12.6s17.8 19.3 12.6 31.5C427.8 424 348.5 480 256 480c-52.5 0-102.8-20.8-139.9-57.9L64 369.9V424c0 13.3-10.7 24-24 24s-24-10.7-24-24V312c0-13.3 10.7-24 24-24z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faSearch: IconDefinition = {
  prefix: 'far',
  iconName: 'magnifying-glass',
  icon: [
    512,
    512,
    ['search'],
    'f002',
    'M368 208A160 160 0 1 0 48 208a160 160 0 1 0 320 0zM337.1 371.1C301.7 399.2 256.8 416 208 416C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208c0 48.8-16.8 93.7-44.9 129.1L505 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L337.1 371.1z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faShareAlt: IconDefinition = {
  prefix: 'far',
  iconName: 'share-nodes',
  icon: [
    448,
    512,
    ['share-alt'],
    'f1e0',
    'M448 128c0 53-43 96-96 96c-28.9 0-54.8-12.8-72.4-33l-89.7 44.9c1.4 6.5 2.1 13.2 2.1 20.1s-.7 13.6-2.1 20.1L279.6 321c17.6-20.2 43.5-33 72.4-33c53 0 96 43 96 96s-43 96-96 96s-96-43-96-96c0-6.9 .7-13.6 2.1-20.1L168.4 319c-17.6 20.2-43.5 33-72.4 33c-53 0-96-43-96-96s43-96 96-96c28.9 0 54.8 12.8 72.4 33l89.7-44.9c-1.4-6.5-2.1-13.2-2.1-20.1c0-53 43-96 96-96s96 43 96 96zM96 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM400 128a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM352 432a48 48 0 1 0 0-96 48 48 0 1 0 0 96z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faSliders: IconDefinition = {
  prefix: 'far',
  iconName: 'sliders',
  icon: [
    512,
    512,
    ['sliders-h'],
    'f1de',
    'M0 416c0 13.3 10.7 24 24 24l59.7 0c10.2 32.5 40.5 56 76.3 56s66.1-23.5 76.3-56L488 440c13.3 0 24-10.7 24-24s-10.7-24-24-24l-251.7 0c-10.2-32.5-40.5-56-76.3-56s-66.1 23.5-76.3 56L24 392c-13.3 0-24 10.7-24 24zm128 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM320 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32-80c-35.8 0-66.1 23.5-76.3 56L24 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l251.7 0c10.2 32.5 40.5 56 76.3 56s66.1-23.5 76.3-56l59.7 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-59.7 0c-10.2-32.5-40.5-56-76.3-56zM192 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm76.3-56C258.1 39.5 227.8 16 192 16s-66.1 23.5-76.3 56L24 72C10.7 72 0 82.7 0 96s10.7 24 24 24l91.7 0c10.2 32.5 40.5 56 76.3 56s66.1-23.5 76.3-56L488 120c13.3 0 24-10.7 24-24s-10.7-24-24-24L268.3 72z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faTableLayout: IconDefinition = {
  prefix: 'far',
  iconName: 'table-layout',
  icon: [
    512,
    512,
    [],
    'e290',
    'M448 80c8.8 0 16 7.2 16 16v64H48V96c0-8.8 7.2-16 16-16H448zM48 416V208h96V432H64c-8.8 0-16-7.2-16-16zm144 16V208H464V416c0 8.8-7.2 16-16 16H192zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faThumbtack: IconDefinition = {
  prefix: 'far',
  iconName: 'thumbtack',
  icon: [
    384,
    512,
    ['thumb-tack'],
    'f08d',
    'M134.6 51.7L123.8 192.6c-1.1 14.6-8.8 27.8-20.9 36C79 244.8 61.1 269.4 53.8 298.9L52.5 304H168V216c0-13.3 10.7-24 24-24s24 10.7 24 24v88H331.5l-1.3-5.1c-7.4-29.5-25.2-54.1-49.1-70.2c-12.1-8.2-19.8-21.5-20.9-36L249.4 51.7c-.1-1.2-.1-2.5-.1-3.7H134.8c0 1.2 0 2.5-.1 3.7zM168 352H32c-9.9 0-19.2-4.5-25.2-12.3S-1.4 321.8 1 312.2l6.2-25c10.3-41.3 35.4-75.7 68.7-98.3L83.1 96l3.7-48H56c-4.4 0-8.6-1.2-12.2-3.3C36.8 40.5 32 32.8 32 24C32 10.7 42.7 0 56 0H86.8 297.2 328c13.3 0 24 10.7 24 24c0 8.8-4.8 16.5-11.8 20.7c-3.6 2.1-7.7 3.3-12.2 3.3H297.2l3.7 48 7.1 92.9c33.3 22.6 58.4 57.1 68.7 98.3l6.2 25c2.4 9.6 .2 19.7-5.8 27.5s-15.4 12.3-25.2 12.3H216V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V352z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faTimes: IconDefinition = {
  prefix: 'far',
  iconName: 'xmark',
  icon: [
    384,
    512,
    ['close', 'multiply', 'remove', 'times'],
    'f00d',
    'M345 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-119 119L73 103c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l119 119L39 375c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l119-119L311 409c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-119-119L345 137z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faTrash: IconDefinition = {
  prefix: 'far',
  iconName: 'trash',
  icon: [
    448,
    512,
    [],
    'f1f8',
    'M177.1 48h93.7c2.7 0 5.2 1.3 6.7 3.6l19 28.4h-145l19-28.4c1.5-2.2 4-3.6 6.7-3.6zM354.2 80L317.5 24.9C307.1 9.4 289.6 0 270.9 0H177.1c-18.7 0-36.2 9.4-46.6 24.9L93.8 80H80.1 32 24C10.7 80 0 90.7 0 104s10.7 24 24 24H35.6L59.6 452.7c2.5 33.4 30.3 59.3 63.8 59.3H324.6c33.5 0 61.3-25.9 63.8-59.3L412.4 128H424c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8H367.9 354.2zm10.1 48L340.5 449.2c-.6 8.4-7.6 14.8-16 14.8H123.4c-8.4 0-15.3-6.5-16-14.8L83.7 128H364.3z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faTrashAlt: IconDefinition = {
  prefix: 'far',
  iconName: 'trash-can',
  icon: [
    448,
    512,
    ['trash-alt'],
    'f2ed',
    'M170.5 51.6L151.5 80h145l-19-28.4c-1.5-2.2-4-3.6-6.7-3.6H177.1c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6L354.2 80H368h48 8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8V432c0 44.2-35.8 80-80 80H112c-44.2 0-80-35.8-80-80V128H24c-13.3 0-24-10.7-24-24S10.7 80 24 80h8H80 93.8l36.7-55.1C140.9 9.4 158.4 0 177.1 0h93.7c18.7 0 36.2 9.4 46.6 24.9zM80 128V432c0 17.7 14.3 32 32 32H336c17.7 0 32-14.3 32-32V128H80zm80 64V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faUser: IconDefinition = {
  prefix: 'far',
  iconName: 'user',
  icon: [
    448,
    512,
    [],
    'f007',
    'M304 128a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM49.3 464H398.7c-8.9-63.3-63.3-112-129-112H178.3c-65.7 0-120.1 48.7-129 112zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faUserPlus: IconDefinition = {
  prefix: 'far',
  iconName: 'user-plus',
  icon: [
    640,
    512,
    [],
    'f234',
    'M144 128a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zm208 0A128 128 0 1 0 96 128a128 128 0 1 0 256 0zM269.7 352c65.7 0 120.1 48.7 129 112H49.3c8.9-63.3 63.3-112 129-112h91.4zm-91.4-48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H224 178.3zM504 312c0 13.3 10.7 24 24 24s24-10.7 24-24V248h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H552V136c0-13.3-10.7-24-24-24s-24 10.7-24 24v64H440c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faUserTag: IconDefinition = {
  prefix: 'far',
  iconName: 'user-tag',
  icon: [
    640,
    512,
    [],
    'f507',
    'M224 208a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM224 0a128 128 0 1 1 0 256A128 128 0 1 1 224 0zM398.7 464c-.5-3.4-1.1-6.7-1.8-10l45.6 45.6c-5.4 7.5-14.2 12.5-24.2 12.5H29.7C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304H224h45.7c17.5 0 34.3 2.5 50.3 7.2v33c0 6.4 .8 12.7 2.3 18.8c-16.1-7.1-33.9-11-52.6-11H178.3c-65.7 0-120.1 48.7-129 112H398.7zM384 224h82.7c17 0 33.3 6.7 45.3 18.7L619.3 350.1c18.7 18.7 18.7 49.1 0 67.9l-73.4 73.4c-18.7 18.7-49.1 18.7-67.9 0L370.7 384c-12-12-18.7-28.3-18.7-45.3V256c0-17.7 14.3-32 32-32zm72 80a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z',
  ],
}

/** @deprecated Font Awesome Pro icon. Use a Lucide icon from `react-icons/lu` instead. */
export const faWarning: IconDefinition = {
  prefix: 'far',
  iconName: 'triangle-exclamation',
  icon: [
    512,
    512,
    ['exclamation-triangle', 'warning'],
    'f071',
    'M248.4 84.3c1.6-2.7 4.5-4.3 7.6-4.3s6 1.6 7.6 4.3L461.9 410c1.4 2.3 2.1 4.9 2.1 7.5c0 8-6.5 14.5-14.5 14.5H62.5c-8 0-14.5-6.5-14.5-14.5c0-2.7 .7-5.3 2.1-7.5L248.4 84.3zm-41-25L9.1 385c-6 9.8-9.1 21-9.1 32.5C0 452 28 480 62.5 480h387c34.5 0 62.5-28 62.5-62.5c0-11.5-3.2-22.7-9.1-32.5L304.6 59.3C294.3 42.4 275.9 32 256 32s-38.3 10.4-48.6 27.3zM288 368a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-8-184c0-13.3-10.7-24-24-24s-24 10.7-24 24v96c0 13.3 10.7 24 24 24s24-10.7 24-24V184z',
  ],
}
